module.exports = __webpack_public_path__ + "teqbahn-assets/media/36.f174b7f1.png";